export enum ProgramPageAttachmentType {
    PDF = 'PDF',
    Video = 'Video'
}
